import React, { useState, useEffect } from "react";
import {
	Grid,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Button,
	Typography
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet-async";

import { FiChevronDown } from "react-icons/fi";

import useStyles from "./styles";
import TextInput from "Components/TextInput";
import Spinner from "Components/Spinner";
import { CEP } from "Components/NumberFormat";

import actions from "store/actions";

import { BankBilletEditState } from "store/reducers/bankBillet/edit";

import ls from "Localization";
import { State } from "store/reducers";
import { useNavigate } from "react-router-dom";

function BankBilletEdit({ match }: any) {
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const classes = useStyles({});

	const [showInfoPanel, setShowInfoPanel] = useState(true);

	useEffect(() => {
		dispatch(actions.bankBillet.edit.clearValues());
	}, [dispatch]);

	useEffect(() => {
		dispatch(actions.bankBillet.edit.getBankBillet(match.params.id));
	}, [dispatch, match.params.id]);

	const bankBillet = useSelector<State, BankBilletEditState>(
		s => s.bankBilletEdit
	);

	if (bankBillet.loading) {
		return null;
	}

	const {
		loading,
		errors,
		email,
		name,
		street,
		number,
		complement,
		neighborhood,
		city,
		state,
		zipCode
	} = bankBillet;

	const handleChange = (id: string, value: any) => {
		const v = { [id]: value };
		dispatch(actions.bankBillet.edit.setValue(v));
	};

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		dispatch(
			actions.bankBillet.edit.updateBankBillet((err, model) => {
				if (err) {
					if (err.code) {
						alert(err.code);
					} else if (typeof err === "string") alert(err);
					else alert(JSON.stringify(err));
				} else {
					navigate("/Dashboard/BankBillet");
				}
			})
		);
	};

	return (
		<form onSubmit={handleSubmit} noValidate>
			<Helmet>
				<title>
					{ls.bankBilletEdit} | {ls.appName}
				</title>
			</Helmet>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Accordion
						TransitionProps={{ unmountOnExit: true }}
						expanded={showInfoPanel}
						onChange={() => setShowInfoPanel(prev => !prev)}
					>
						<AccordionSummary
							expandIcon={<FiChevronDown />}
							aria-controls="finishes-content"
							id="finishes-header"
						>
							<Typography className={classes.heading} variant="h6">
								Editar boleto
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="name"
										name="name"
										value={name}
										required
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="email"
										name="email"
										value={email}
										required
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} />
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="zipCode"
										name="zipCode"
										InputProps={{
											inputComponent: CEP
										}}
										value={zipCode}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={8}>
									<TextInput
										errors={errors}
										id="street"
										name="street"
										value={street}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="number"
										name="number"
										value={number}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="complement"
										name="complement"
										value={complement}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} lg={4}>
									<TextInput
										errors={errors}
										id="neighborhood"
										name="neighborhood"
										value={neighborhood}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} lg={4}>
									<TextInput
										errors={errors}
										id="city"
										name="city"
										required
										value={city}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="state"
										name="state"
										required
										inputProps={{
											maxLength: 2
										}}
										value={state}
										onChange={handleChange}
									/>
								</Grid>
							</Grid>
						</AccordionDetails>
					</Accordion>
				</Grid>

				<Grid item xs={12}>
					<Grid container justifyContent="flex-end">
						<Grid item>
							<Button
								disabled={loading}
								variant="contained"
								color="secondary"
								type="submit"
							>
								Salvar
								{loading && <Spinner size={20} style={{ marginLeft: 16 }} />}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
}

export default BankBilletEdit;
